// extracted by mini-css-extract-plugin
export default {"card":"Card_card__9h8Dh","hover":"Card_hover__JYsJy","cardHeader":"Card_cardHeader__i85Km","cardContent":"Card_cardContent__ZllWd","cardFooter":"Card_cardFooter__tOiL3"};